import React from 'react';

/**
 * Illustrations of the three Malaysian house types (kampung, terrace, bungalow)
 */
const HouseIllustration = ({ type }) => {
  if (type === 'kampung') {
    return (
      <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
        {/* Stilts */}
        <rect x="15" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        <rect x="62" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        <rect x="38" y="32" width="3" height="16" fill="#8B6914" rx="0.5"/>
        {/* House body (wood) */}
        <rect x="10" y="20" width="60" height="14" fill="#D2A679" stroke="#A0784C" strokeWidth="0.5" rx="1"/>
        {/* Roof - traditional steep */}
        <polygon points="40,2 5,22 75,22" fill="#8B4513" stroke="#6B3410" strokeWidth="0.5"/>
        <polygon points="40,5 10,22 70,22" fill="#A0522D"/>
        {/* Window */}
        <rect x="22" y="24" width="8" height="6" fill="#87CEEB" stroke="#A0784C" strokeWidth="0.5" rx="0.5"/>
        {/* Door */}
        <rect x="44" y="22" width="7" height="12" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
        {/* Stairs */}
        <line x1="51" y1="34" x2="58" y2="48" stroke="#8B6914" strokeWidth="1.5"/>
        <line x1="44" y1="34" x2="51" y2="48" stroke="#8B6914" strokeWidth="1.5"/>
        {/* Ground */}
        <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
      </svg>
    );
  }
  if (type === 'terrace') {
    return (
      <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
        {/* Left neighbor hint */}
        <rect x="0" y="15" width="8" height="33" fill="#C0C0C0" opacity="0.4"/>
        {/* Right neighbor hint */}
        <rect x="72" y="15" width="8" height="33" fill="#C0C0C0" opacity="0.4"/>
        {/* Main house body */}
        <rect x="8" y="15" width="64" height="33" fill="#E8DDD3" stroke="#B0A090" strokeWidth="0.5"/>
        {/* Roof */}
        <polygon points="8,15 40,3 72,15" fill="#7A3B2E" stroke="#5C2D1E" strokeWidth="0.5"/>
        {/* Upper window */}
        <rect x="30" y="18" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="35" y1="18" x2="35" y2="26" stroke="#B0A090" strokeWidth="0.3"/>
        {/* Door */}
        <rect x="33" y="32" width="10" height="16" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
        <circle cx="41" cy="40" r="0.8" fill="#DAA520"/>
        {/* Windows */}
        <rect x="16" y="32" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="21" y1="32" x2="21" y2="40" stroke="#B0A090" strokeWidth="0.3"/>
        <rect x="52" y="32" width="10" height="8" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
        <line x1="57" y1="32" x2="57" y2="40" stroke="#B0A090" strokeWidth="0.3"/>
        {/* Car porch line */}
        <line x1="8" y1="30" x2="72" y2="30" stroke="#B0A090" strokeWidth="0.3" strokeDasharray="2,1"/>
        {/* Ground */}
        <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
      </svg>
    );
  }
  // bungalow
  return (
    <svg viewBox="0 0 80 50" style={{ width: '100%', height: '100%' }}>
      {/* Main body */}
      <rect x="5" y="18" width="70" height="30" fill="#E8DDD3" stroke="#B0A090" strokeWidth="0.5" rx="1"/>
      {/* Roof */}
      <polygon points="40,2 0,20 80,20" fill="#5C4033" stroke="#4A3328" strokeWidth="0.5"/>
      <polygon points="40,5 5,20 75,20" fill="#6B4C3B"/>
      {/* Porch extension */}
      <rect x="28" y="28" width="24" height="20" fill="#F0E6DC" stroke="#B0A090" strokeWidth="0.5"/>
      <polygon points="28,28 40,22 52,28" fill="#7A5C4B" stroke="#5C4033" strokeWidth="0.3"/>
      {/* Door */}
      <rect x="36" y="34" width="8" height="14" fill="#6B3410" stroke="#5C2D0E" strokeWidth="0.5" rx="0.5"/>
      <circle cx="42" cy="41" r="0.7" fill="#DAA520"/>
      {/* Windows */}
      <rect x="10" y="26" width="12" height="9" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
      <line x1="16" y1="26" x2="16" y2="35" stroke="#B0A090" strokeWidth="0.3"/>
      <line x1="10" y1="30.5" x2="22" y2="30.5" stroke="#B0A090" strokeWidth="0.3"/>
      <rect x="58" y="26" width="12" height="9" fill="#87CEEB" stroke="#B0A090" strokeWidth="0.5" rx="0.5"/>
      <line x1="64" y1="26" x2="64" y2="35" stroke="#B0A090" strokeWidth="0.3"/>
      <line x1="58" y1="30.5" x2="70" y2="30.5" stroke="#B0A090" strokeWidth="0.3"/>
      {/* Garden hints */}
      <circle cx="8" cy="46" r="3" fill="#4a7c59" opacity="0.3"/>
      <circle cx="72" cy="46" r="3" fill="#4a7c59" opacity="0.3"/>
      {/* Ground */}
      <line x1="0" y1="48" x2="80" y2="48" stroke="#4a7c59" strokeWidth="1" opacity="0.5"/>
    </svg>
  );
};

export default HouseIllustration;
